exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#IdentificationWrapper .v-list__tile{height:auto!important}#IdentificationWrapper .btn--card{position:absolute;right:10px;bottom:10px}#IdentificationWrapper .v-list{position:relative}#IdentificationWrapper .caption--identification{display:inline;text-align:center;vertical-align:super}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6311d6a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/map/modals/Identification.vue
// module id = 2134
// module chunks = 0